import type { StaffCoordinationSuggestionV2Response } from '@/types/apps/staff-coordination-suggestion-v2.type';
import type {
    ApiResponse,
    PaginatedResult,
    QueryParams,
} from '@/types/common/api.type';
import type { BaseApiClientInterface } from '@/types/service/base-api-client.interface';
import type { Indexable } from '@/types/service/indexable.interface';

export interface StaffCoordinationSuggestionV2ServiceInterface {}

type StaffCoordinationSuggestionV2ListResponse = ApiResponse<
    PaginatedResult<StaffCoordinationSuggestionV2Response>
>;

export class StaffCoordinationSuggestionV2Service implements Indexable {
    public constructor(private apiClient: BaseApiClientInterface) {}

    protected endpoints = {
        base: () => '/api/v2/staff-coordination/suggestion',
    };

    public index(
        params?: QueryParams
    ): Promise<StaffCoordinationSuggestionV2ListResponse> {
        return this.apiClient
            .fetchApi<
                PaginatedResult<StaffCoordinationSuggestionV2Response>
            >(this.endpoints.base(), params)
            .then(res => {
                const items = res.result.items.map(item => ({
                    ...item,
                    name: item.fullName,
                }));

                return {
                    ...res,
                    result: { ...res.result, items },
                };
            });
    }
}
